import { LanguageLocale } from '../models/language-locale'
import { StorageService } from './storage.service'
import { WindowService } from './window.service'
import { EnvironmentName } from '../models/environment-name'

export class LocaleService {
  private static readonly LOCALE_ID_STORAGE_KEY = 'LocaleId'
  private _languageLocal?: LanguageLocale

  public get languageLocale(): LanguageLocale {
    if (this._languageLocal) {
      return this._languageLocal
    }

    const savedLocaleId =
      this.storageService.getItemStr(LocaleService.LOCALE_ID_STORAGE_KEY) ?? ''

    const savedLanguageLocale = this.languageLocales.find(
      (languageLocale) => languageLocale.localeId === savedLocaleId,
    )

    this._languageLocal = savedLanguageLocale
    return savedLanguageLocale ?? this.languageLocales[0]
  }

  public readonly languageLocales: LanguageLocale[] = [
    new LanguageLocale('English', 'en'),
    new LanguageLocale('Srpski', 'sr'),
  ]

  public constructor(
    private readonly storageService: StorageService,
    private readonly appLocaleId: string,
    private readonly windowService: WindowService,
    private readonly environmentName: EnvironmentName,
  ) {}

  public setLanguageLocale(languageLocale: LanguageLocale): void {
    this.storageService.setItemStr(
      LocaleService.LOCALE_ID_STORAGE_KEY,
      languageLocale.localeId,
    )

    this._languageLocal = languageLocale
  }

  public isUserLocaleDifferentFromAppLocale(): boolean {
    if (this.environmentName === 'local') {
      return false
    }

    return !this.appLocaleId.includes(this.languageLocale.languageId)
  }

  public reload(languageLocale: LanguageLocale): void {
    const localeIds = this.languageLocales.map(
      (languageLocale) => languageLocale.localeId,
    )

    const pathnameWithLocaleStripped =
      this.windowService.getPathnameWithStrippedPathSegments(localeIds)

    const url = `${this.windowService.origin}/${languageLocale.localeId}${pathnameWithLocaleStripped}`
    this.windowService.reload(url)
  }
}
